var _path, _path2, _path3, _rect, _path4, _path5, _circle;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSad(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.9729 10.054C21.9729 9.13505 21.8624 8.24201 21.6561 7.38651C21.0668 6.15787 20.2494 5.05872 19.2595 4.14347C17.444 3.05891 15.3055 2.46782 13.0347 2.55061C6.7697 2.77902 1.87615 8.04303 2.10448 14.308C2.13796 15.2246 2.28043 16.1112 2.51694 16.9572C3.028 17.931 3.68428 18.8171 4.45756 19.5859C6.23261 20.7364 8.3487 21.4054 10.6217 21.4054C16.8907 21.4054 21.9729 16.3231 21.9729 10.054ZM16.0135 8.10806C16.7299 8.10806 17.3108 8.68893 17.3108 9.40537C17.3108 10.1218 16.7299 10.7027 16.0135 10.7027C15.297 10.7027 14.7162 10.1218 14.7162 9.40537C14.7162 8.68893 15.297 8.10806 16.0135 8.10806ZM7.98636 8.10806C8.7028 8.10806 9.28367 8.68893 9.28367 9.40537C9.28367 10.1218 8.7028 10.7027 7.98636 10.7027C7.26991 10.7027 6.68904 10.1218 6.68904 9.40537C6.68904 8.68893 7.26991 8.10806 7.98636 8.10806ZM5.25388 15.5001L18.4814 12.7433L18.746 14.0134L5.51853 16.7701L5.25388 15.5001Z",
    fill: "#FFCE00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.6562 7.38651C21.8624 8.24208 21.9729 9.13504 21.9729 10.054C21.9729 16.3231 16.8907 21.4054 10.6216 21.4054C8.3487 21.4054 6.23254 20.7364 4.45749 19.5859C6.39373 21.5111 9.0602 22.7027 12 22.7027C17.9015 22.7027 22.7027 17.9015 22.7027 12C22.7027 10.349 22.3266 8.7842 21.6562 7.38651Z",
    fill: "#FFB100"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0348 2.55059C15.3055 2.4678 17.4441 3.05881 19.2596 4.14345C17.3504 2.37797 14.7992 1.2973 12 1.2973C6.0985 1.2973 1.2973 6.0985 1.2973 12C1.2973 13.7878 1.73855 15.4743 2.51694 16.9572C2.28042 16.1112 2.13796 15.2245 2.10448 14.308C1.87615 8.04301 6.7697 2.779 13.0348 2.55059Z",
    fill: "#FFE454"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 18.746,
    y: 14.014,
    width: 13.5125,
    height: 1.29735,
    transform: "rotate(168.229 18.746 14.014)",
    fill: "#393939"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.98634 10.7027C8.70283 10.7027 9.28366 10.1219 9.28366 9.40538C9.28366 8.68889 8.70283 8.10806 7.98634 8.10806C7.26985 8.10806 6.68903 8.68889 6.68903 9.40538C6.68903 10.1219 7.26985 10.7027 7.98634 10.7027Z",
    fill: "#393939"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0135 10.7027C16.73 10.7027 17.3108 10.1219 17.3108 9.40538C17.3108 8.68889 16.73 8.10806 16.0135 8.10806C15.297 8.10806 14.7162 8.68889 14.7162 9.40538C14.7162 10.1219 15.297 10.7027 16.0135 10.7027Z",
    fill: "#393939"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 11.4,
    stroke: "#393939",
    strokeWidth: 1.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSad);
export default __webpack_public_path__ + "static/media/sad.62f69a20862363ad7e1c318fe6888740.svg";
export { ForwardRef as ReactComponent };